/**
 * Хак типов нужный для стабильной работы unionize.
 */
export const unionizeConfig = {
  tag: 'type',
  value: 'payload',
} as {tag: 'type'; value: 'payload'};
